import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/services/api.service';
import { TypeFieldEnum } from '@shared/components/dynamic-form/components/dynamic-form/dynamic-form.component';
import { map, of } from 'rxjs';
import { environment } from '@env/environment';

const baseUrl = `/capitulos`;
const routes = {
  insert: baseUrl,
  edit: (idCapitulo: number) => `${baseUrl}/${idCapitulo}`,
  consult: `${baseUrl}/consultar`,
  consultId: (idCapitulo: number) => `${baseUrl}/${idCapitulo}`,
  mudarStatus: (idCapitulo: number) => `${baseUrl}/${idCapitulo}/ativar-desativar`,
  generateSynopsis: `generate_synopsis`,
  reviewSynopsis: `review_synopsis`,
  batch: `control_fluxo`,
  exportSinopses: `${baseUrl}/exportar_sinopses`,
  exportSinopsesXLSX: `${baseUrl}/exportar_sinopses-xlsx`,
}

@Injectable({
  providedIn: 'root'
})
export class CapituloService {

  constructor(private apiService: ApiService) { }

  cadastrar(obj: any) {
    return this.apiService.post(routes.insert, obj);
  }

  editar(idCapitulo: number, obj: any) {
    return this.apiService.put(routes.edit(idCapitulo), obj);
  }

  consultar(obj: any, page: number, pageSize: number) {
    let params = new HttpParams();
    params = params.append('size', pageSize);
    params = params.append('page', page - 1);
    return this.apiService.post<any>(routes.consult, obj, undefined, undefined, params);
  }

  consultarPorId(idCapitulo: number) {
    return this.apiService.get<any>(routes.consultId(idCapitulo));
  }

  mudarStatus(idCapitulo: number, obj: any) {
    return this.apiService.patch(routes.mudarStatus(idCapitulo), obj);
  }

  listar() {
    return this.apiService.get<any>(routes.insert);
  }

  generateSynopsis(obj: any) {
    return this.apiService.postCustomApi(`${environment.apiIA}/${routes.generateSynopsis}`, obj);
  }

  reviewSynopsis(obj: any) {
    return this.apiService.postCustomApi(`${environment.apiIA}/${routes.reviewSynopsis}`, obj);
  }

  batchIA(obj: any) {
    return this.apiService.postCustomApi(`${environment.apiIA}/${routes.batch}`, obj);
  }

  exportSinopses(obj: any) {
    return this.apiService.downloadPost(routes.exportSinopses, obj).pipe(
      map((response: any) => {
        const blob = response.body;

        const now = new Date();
        const formattedDate = now.toISOString().replace(/[-:T]/g, '').slice(0, 14);
        const fileName = `relatorio-sinopses_${formattedDate}.pdf`;
  
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
  
        return response;
      })
    );
  }

  exportSinopsesXLSX(obj: any) {
    return this.apiService.downloadPost(routes.exportSinopsesXLSX, obj).pipe(
      map((response: any) => {
        const blob = response.body;

        const now = new Date();
        const formattedDate = now.toISOString().replace(/[-:T]/g, '').slice(0, 14);
        const fileName = `relatorio-sinopses_${formattedDate}.xlsx`;
  
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
  
        return response;
      })
    );
  }

  fieldsListForm() {
    return of([
      { name: 'numeroCapitulo', label: 'Nº Capítulo', type: TypeFieldEnum.Input, required: false },
      { name: 'quantidadeCenas', label: 'Quantidade Cenas', type: TypeFieldEnum.Input, required: false },
      { name: 'statusCapitulo', label: 'Situação', type: TypeFieldEnum.Select, list: 'situacaoLista', optionValueFn: 'item', required: false },
      { name: 'ativo', label: 'Status', type: TypeFieldEnum.Select, list: 'statusLista', optionValueFn: 'id', required: false },
      { name: 'statusSinopse', label: 'Status Sinopse', type: TypeFieldEnum.Select, list: 'statusSinopseLista', optionValueFn: 'item', required: false }
    ])
  }
}
